import * as loadingState from '@coconut/constants/loadingState';
import { PICK, DECLINE } from '@coconut/constants/openQuestionStatus';

export const types = {
  QUERY_OPEN_QUESTIONS: 'QUERY_OPEN_QUESTIONS',
  QUERY_OPEN_QUESTIONS_SUCCESS: 'QUERY_OPEN_QUESTIONS_SUCCESS',
  QUERY_OPEN_QUESTIONS_FAILURE: 'QUERY_OPEN_QUESTIONS_FAILURE',
  PICK_QUESTION: 'PICK_QUESTION',
  PICK_QUESTION_SUCCESS: 'PICK_QUESTION_SUCCESS',
  PICK_QUESTION_FAILURE: 'PICK_QUESTION_FAILURE',
  DECLINE_QUESTION: 'DECLINE_QUESTION',
  DECLINE_QUESTION_SUCCESS: 'DECLINE_QUESTION_SUCCESS',
  DECLINE_QUESTION_FAILURE: 'DECLINE_QUESTION_FAILURE',
  SELECT_FILTER_OF_SUBJECT: 'SELECT_FILTER_OF_SUBJECT',
};

export const selectFilterOfSubject = (filter) => ({
  type: types.SELECT_FILTER_OF_SUBJECT,
  payload: {
    filter,
  },
});

export const queryOpenQuestions = () => ({
  type: types.QUERY_OPEN_QUESTIONS,
});

export const queryOpenQuestionsSuccess = (questions) => ({
  type: types.QUERY_OPEN_QUESTIONS_SUCCESS,
  payload: {
    questions,
  },
});

export const queryOpenQuestionsFailure = (error) => ({
  type: types.QUERY_OPEN_QUESTIONS_FAILURE,
  payload: {
    error,
  },
});

export const pickQuestion = (questionId) => ({
  type: types.PICK_QUESTION,
  payload: {
    questionId,
  },
});

export const pickQuestionSuccess = (questionId) => ({
  type: types.PICK_QUESTION_SUCCESS,
  payload: {
    questionId,
  },
});

export const pickQuestionFailure = (error) => ({
  type: types.PICK_QUESTION_FAILURE,
  payload: {
    error,
  },
});

export const declineQuestion = (questionId) => ({
  type: types.DECLINE_QUESTION,
  payload: {
    questionId,
  },
});

export const declineQuestionSuccess = (questionId) => ({
  type: types.DECLINE_QUESTION_SUCCESS,
  payload: {
    questionId,
  },
});

export const declineQuestionFailure = (error) => ({
  type: types.DECLINE_QUESTION_FAILURE,
  payload: {
    error,
  },
});

const initialState = {
  state: loadingState.EMPTY,
  questions: [],
  filter: undefined,
};

function updateQuestionStatus(questions, questionId, status) {
  const question = questions.find((q) => q.id === questionId);
  if (question) {
    question.status = status;
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.QUERY_OPEN_QUESTIONS:
      return {
        ...state,
      };
    case types.QUERY_OPEN_QUESTIONS_SUCCESS:
      return {
        ...state,
        state: loadingState.READY,
        questions: action.payload.questions,
      };
    case types.PICK_QUESTION:
      return {
        ...state,
        state: loadingState.LOADING,
      };
    case types.PICK_QUESTION_SUCCESS: {
      const questions = state.questions;
      const questionId = action.payload.questionId;
      updateQuestionStatus(questions, questionId, PICK);

      return {
        ...state,
        state: loadingState.READY,
      };
    }
    case types.PICK_QUESTION_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    case types.DECLINE_QUESTION:
      return {
        ...state,
        state: loadingState.LOADING,
      };
    case types.DECLINE_QUESTION_SUCCESS: {
      const questions = state.questions;
      const questionId = action.payload.questionId;
      updateQuestionStatus(questions, questionId, DECLINE);

      return {
        ...state,
        state: loadingState.READY,
      };
    }
    case types.DECLINE_QUESTION_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    case types.SELECT_FILTER_OF_SUBJECT: {
      return {
        ...state,
        filter: action.payload.filter,
      };
    }
    default:
      return {
        ...state,
      };
  }
}

export const getOpenQuestions = (state) => state.openQuestion.questions;
export const getOpenQuestionState = (state) => state.openQuestion.state;
export const getOpenQuestionFilter = (state) => state.openQuestion.filter;



// WEBPACK FOOTER //
// ./src/services/redux/openQuestion.js